/**
 * Публічні контакти клубу — ADR-0016.
 *
 * Джерело віддає їх окремими полями (`contacts.phone`, `email`, `website`,
 * `instagram`, `facebook`), але без спільного формату: телефон приходить самими
 * цифрами, соцмережа — то повним посиланням, то самим псевдонімом, сайт — з
 * протоколом або без. Тому нормалізація тут, одним місцем, а не в розмітці.
 *
 * Було: helpers/socialsFormatting.js — вгадування за довжиною рядка й перевіркою
 * на кириличні літери, бо в старому API все це лежало в довільних текстових
 * полях. Вгадувати більше нема чого.
 */

/** +380 93 824 64 37 — інші формати лишаються як є. */
function phoneLabel(digits) {
  const ua = digits.match(/^\+?38(0\d{2})(\d{3})(\d{2})(\d{2})$/);
  return ua ? `+38 (${ua[1]}) ${ua[2]} ${ua[3]} ${ua[4]}` : digits;
}

function socialLink(network, value) {
  const trimmed = value.trim();

  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  return `https://${network}.com/${trimmed.replace(/^@/, '')}`;
}

function websiteLink(value) {
  const trimmed = value.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

/** Адреса сайту без протоколу й службового хвоста — для підпису посилання. */
function websiteLabel(value) {
  return value
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '')
    .replace(/\/$/, '');
}

/**
 * Контакти -> перелік готових посилань. Порожні поля не потрапляють сюди
 * зовсім: на сторінці не має бути ані підпису без значення, ані прочерку.
 *
 * @returns {Array<{ key: string, href: string, label: string }>}
 */
export function contactLinks(contacts = {}) {
  const { phone, email, website, instagram, facebook } = contacts || {};

  const links = [];

  if (phone) {
    const digits = String(phone).replace(/[^\d+]/g, '');
    if (digits) links.push({ key: 'phone', href: `tel:${digits.startsWith('+') ? digits : `+${digits}`}`, label: phoneLabel(digits) });
  }

  if (email && String(email).includes('@')) {
    links.push({ key: 'email', href: `mailto:${String(email).trim()}`, label: String(email).trim() });
  }

  if (website) {
    links.push({ key: 'website', href: websiteLink(String(website)), label: websiteLabel(String(website)) });
  }

  if (instagram) {
    links.push({ key: 'instagram', href: socialLink('instagram', String(instagram)), label: 'Instagram' });
  }

  if (facebook) {
    links.push({ key: 'facebook', href: socialLink('facebook', String(facebook)), label: 'Facebook' });
  }

  return links;
}
